import React from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'reactstrap'
import { HelpNavItem } from './help-nav-item'
import { LogoutNavItem } from './logout-nav-item'
import { ResourceCenterNavItem } from './resource-center'

export function Navigation (props) {
  return (
    <Nav className='ml-auto' aria-label='top level'>
      <ResourceCenterNavItem url={props.url}/>
      <HelpNavItem url={props.url} />
      <LogoutNavItem url={props.url} />
    </Nav>
  )
}

Navigation.propTypes = {
  url: PropTypes.object
}
